import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchBatches = createAsyncThunk("batches/fetch", async () => {
  const res = await api.get("/vendor/batches");
  return res.data.batches;
});

export const createBatch = createAsyncThunk(
  "batches/create",
  async ({ recipeId, readyTime, quantity }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/vendor/recipes/${recipeId}/batches`, {
        readyTime,
        quantity,
      });
      return res.data.batch;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.error || "Failed to create batch"
      );
    }
  }
);

const batchesSlice = createSlice({
  name: "batches",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBatches.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchBatches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createBatch.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      });
  },
});

export default batchesSlice.reducer;
